import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, change } from 'redux-form';
import { withStyles, Grid, Stepper, Step, StepLabel } from './../../../themes/default';
import { Btn } from './../../../components/includes/ui';
import { Modal } from './../../../components/includes/modal';
import { InputTextField } from './../../../components/includes/ui/input';
import { Table, Thead, Tbody, Row, Cell, Tresponsive } from './../../../components/includes/ui/table';
import { SnackbarStatic } from './../../../components/includes/snackbar';
import { Buttons } from './../../../components/includes/container';
import { capitalize } from './../../../utilities/utils';
import { PollService } from './../../../services';

const steps = [
    'Listado de usuarios',
    'Confirmación de usuarios'
];

const rows = [
  { id: 'identifire', sort: false, numeric: false, disablePadding: false, label: 'Identificador' },
  { id: 'first_name', sort: false, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'last_name', sort: false, numeric: false, disablePadding: false, label: 'Apellido' },
  { id: 'email', sort: false, numeric: false, disablePadding: false, label: 'Email' }
];

const validate = values => {

  const errors = {}

  return errors;

}

const styles = theme => ({
  stepperToolbar: {
    paddingBottom: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    borderBottom: `1px solid ${ theme.palette.grey[300] }`
  },
  stepper: {
    padding: 0
  }
});

class PollImport extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      sending: false,
      activeStep: 1,
      users: []
    };
  }

  componentDidUpdate(){

  }

  /*
  ** @Service
  ** @Description: Import
  */

  _Import = (users) => {

    // @State
    this.setState({ sending: true });

    // @Service
    PollService.importUsers({ users: users, id: this.props.id  }).then((response) => {

      // @Props
      // @Description: Send confirm to parent
      this.props.confirm();

      // @Dispatch
      // @Description: Alert success
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, se importaron correctamente los usuarios.` });

      // @State
      this.setState({ sending: false, activeStep: 1, users: [] });

      // @Form
      this.props.dispatch(change('PollImport', 'rows', ''));

    }).catch((error) => {

      // @Dispatch
      // @Description: Alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

      // @State
      this.setState({ sending: true });

    });

  }

  /*
  ** @Submit
  ** @Description: Submit import form
  */

  handleSubmitForm = (values) => {

    if(values.rows){

      let rows  = values.rows.trim().split('\n');
      let users = [];

      rows.forEach((row, index) => {

        let data = row.split(',');

        if(data.length === 4){
          users.push({
            first_name: capitalize(data[0].toLowerCase()),
            last_name:  capitalize(data[1].toLowerCase()),
            email:      data[2].toLowerCase(),
            identifire: data[3]
          });
        }

      });

      // @Validation
      // @Description: Debemos tener al menos 1 resultado
      if(users.length > 0){

        this.setState({
          activeStep: this.state.activeStep + 1,
          users: users
        });

      }else{

        // @Dispatch
        // @Description: Alert error
        this.props.AlertShow({ open: true, variant: 'error', message: 'Error de estructura en la importación' });

      }

    }else {

      // @Dispatch
      // @Description: Alert error
      this.props.AlertShow({ open: true, variant: 'error', message: 'Error de estructura en la importación' });

    }

  }

  /*
  ** @Submit
  ** @Description: Next
  */

  handleNext = () => {
    this.formReference.dispatchEvent(new Event("submit"));
  }

  /*
  ** @Submit
  ** @Description: Back
  */

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  }

  /*
  ** @Submit
  ** @Description: Finish
  */

  handleFinish = () => {

    this._Import(this.state.users);

  }

  /*
  ** @Event
  ** @Description: Close add new users to poll
  */

  handleCancelImport = () => {

    // @Props
    // @Description: Send cancel to parent
    this.props.cancel();

    // @State
    this.setState({ sending: false, activeStep: 1, users: [] });

    // @Form
    this.props.dispatch(change('PollImport', 'rows', ''));

  }

  render() {

    const { users, activeStep, sending } = this.state;
    const { classes, status, handleSubmit } = this.props;

    return(

      <Modal
          status={ status }
          title={ `Importación de usuarios` }
          handleCancel={ this.handleCancelImport }
          maxWidth="md"
          actions={
            <Buttons align="right">
              { (activeStep > 1 && activeStep <= steps.length) && (
                <Btn aria-label="Volver" icon="back" color="secondary" onClick={ this.handleBack }>
                  Volver
                </Btn>
              )}
              { (activeStep >= 1 && activeStep <= (steps.length - 1)) && (
                <Btn aria-label="Siguiente" icon="forward" color="primary" onClick={ this.handleNext }>
                  Siguiente
                </Btn>
              )}
              { activeStep === steps.length && (
                <Btn aria-label="Confirmar" icon="add" color="success" onClick={ this.handleFinish } loading={ sending }>
                  Confirmar
                </Btn>
              )}
            </Buttons>
          }
      >

        <React.Fragment>

          <div className={ classes.stepperToolbar }>
            <Stepper activeStep={ activeStep } alternativeLabel classes={{
              root: classes.stepper
            }}>
              {steps.map(label => {
                return (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>

          <div className={ classes.steperContent }>
            {activeStep === steps.length ? (

              <Tresponsive>
                <Table>
                  <Thead rows={ rows }/>
                  <Tbody>
                    { users.map(user => {
                      return (
                        <Row key={ user.identifire }>
                          <Cell>
                            { user.identifire }
                          </Cell>
                          <Cell>
                            { user.first_name }
                          </Cell>
                          <Cell>
                            { user.last_name }
                          </Cell>
                          <Cell>
                            { user.email }
                          </Cell>
                        </Row>
                      )
                    })}
                  </Tbody>
                </Table>
              </Tresponsive>

            ) : (

              <React.Fragment>

                { activeStep === 1 && (
                  <form
                    noValidate
                    autoComplete="off"
                    onSubmit={ handleSubmit(this.handleSubmitForm) }
                    ref={form => this.formReference = form}
                  >
                    <Grid container spacing={24}>
                    <Grid item xs={12}>
                      <SnackbarStatic
                        icon="info"
                        variant="warning"
                        message="El listado de usuarios debera ser un CSV separado por comas y el siguiente orden: Nombre, Apellido, Email, Identificador."
                        open={true}
                        fullWidth hideClose/>
                    </Grid>
                      <Grid item xs={12}>
                        <Field
                            name="rows"
                            multiline
                            rows="10"
                            component={ InputTextField }
                            label="Usuarios"
                            required
                        />
                      </Grid>

                    </Grid>
                  </form>
                )}

              </React.Fragment>

            )}
          </div>

        </React.Fragment>

      </Modal>

    )
  }

}

PollImport = reduxForm({
  form: 'PollImport',
  validate,
  initialValues: {},
  enableReinitialize: true
})(PollImport);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PollImport));
